import {
  Box,
  Button,
  IconChatBubbleOutline,
  Typography,
  IconClear,
  useLayout,
  theme,
} from '@capitalise/ui-design-system';
import withOpenIntercom from 'HOC/withOpenIntercom';
import { use100vh } from 'react-div-100vh';

export const directorTips = [
  {
    title: 'Director’s home address',
    description:
      'Ensure the address details are a director’s home address and not the registered business address.',
  },
  {
    title: 'House and building number separate',
    description: 'Keep the house and building number separate from the street name.',
  },
  {
    title: 'Beware of browser autocomplete',
    description: 'Watch out for using autofill from your browser.',
  },
  {
    title: 'Moved home within the past year?',
    description: 'You may need to try your previous address.',
  },
];

const DirectorInfoPanel = () => {
  const height = use100vh();
  const { closeRightBarOverlay } = useLayout();
  const IntercomLink = withOpenIntercom(Button);

  return (
    <Box display="flex" flexDirection="column" height={`${height}px`} overflow="auto">
      <Box position="relative" padding="medium">
        <Box
          height="small"
          width="small"
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginLeft="tiny"
          backgroundColor="grey-50"
          cursor="pointer"
          position="absolute"
          right={theme.sizes['tiny']}
          top={theme.sizes['tiny']}
          onClick={closeRightBarOverlay}
        >
          <IconClear width="3xsmall" color="grey-500" />
        </Box>
        <Box marginBottom="3xsmall" marginTop="2xlarge">
          <Typography size="section-header-14" color="grey-500">
            director consent
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="heading-28">
            Why do we need to verify the director’s details?
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="body-18">
            For data security and to access your full credit profile, we need to verfiy that you are
            a director of the business. Please provide your details below so we can confirm the
            details match the company records.
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="heading-22">
            Not a director? Or unable to verify the details right now?
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="body-16">
            No problem, you can still continue to upgrade your plan and will be able to verify
            later, given you’re a director of the company. You’ll still have access to premium
            features except those where Experian verification is required.
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="heading-22">Tips for filling out the form</Typography>
        </Box>
        {directorTips.map((tip, index) => (
          <Box display="list-item" ml="3xsmall" key={`tip_${index}`}>
            <Typography size="heading-18" color="grey-700">
              {tip.title}
            </Typography>
            <Typography size="body-16">{tip.description}</Typography>
          </Box>
        ))}
      </Box>
      <Box
        display="flex"
        marginTop="auto"
        justifyContent="space-between"
        alignItems="center"
        paddingY="3xsmall"
        paddingX="medium"
        borderTop={`1px solid ${theme.colors['grey-50']}`}
      >
        <Box>
          <Typography size="heading-18">Still need help?</Typography>
          <Typography size="body-16">Start a chat to ask a question.</Typography>
        </Box>
        <IntercomLink baseColor="green" leftIcon={<IconChatBubbleOutline />} variant="outlined">
          Start a chat
        </IntercomLink>
      </Box>
    </Box>
  );
};

export default DirectorInfoPanel;
